
import MuiToolbar from '@mui/material/Toolbar';

interface IProps {
  children: React.ReactNode;
  disableGutters?: boolean;
}

/**
 * En toolbar
 *
 * se https://material-ui.com/api/toolbar/#toolbar-api
 */
const EDToolbar = (props: IProps) => (
  <MuiToolbar disableGutters={props.disableGutters}>
    {props.children}
  </MuiToolbar>
);

export default EDToolbar;
